import React from 'react'
import Script from 'next/script'

interface BranchLoaderProps {
  branchKey?: string
  title?: string | null
  description?: string | null
  imageUrl?: string | null
  offerId?: string | null
  centreSlug?: string | null
}

const BranchLoader: React.FC<React.PropsWithChildren<BranchLoaderProps>> = ({
  branchKey,
  title,
  description,
  imageUrl,
  offerId,
  centreSlug,
}) => {
  if (!branchKey) {
    return null
  }
  return (
    <Script
      id="load-and-initialize-branch"
      dangerouslySetInnerHTML={{
        __html: `// load Branch
        let branchKey = '${branchKey}';
        if (branchKey.length > 0) {
          (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking qrCode".split(" "), 0);
          branch.init(branchKey, function (err, data) {
            branch.setBranchViewData({
              data: {
                title: "${title}",
                description: "${description}",
                image: "${imageUrl}",
                offerId: "${offerId}",
                centreSlug: "${centreSlug}"
              }
            })
          });
        }`,
      }}
    />
  )
}

export default BranchLoader
